import { Form, message, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from "react";
import wish from "../../../server/celebration";
import { SmilePlus } from "lucide-react";
import EmojiPicker, { EmojiStyle } from "emoji-picker-react";


interface ISendWishModalProps {
    openModal: boolean;
    setModalOpen: (open: boolean) => void;
    employeeId: string | null;
}

const WishEmailModal = ({openModal, setModalOpen, employeeId}: ISendWishModalProps) => {
    const [form] = Form.useForm();
    const [msg, setMsg] = useState<string>('');
    const [openEmojiPicker, setOpenEmojiPicker] = useState<boolean>(false);
    const emojiRef = useRef<HTMLDivElement | null>(null);
    const textAreaRef = useRef<any>(null);
    const selectionRef = useRef({start: 0, end: 0});



    useEffect(() => {
        function handleOutsideClick(event: any) {
            if (emojiRef.current &&
                !emojiRef.current.contains(event.target)) {
                setOpenEmojiPicker(false);
            }
        }

        document.addEventListener("mousedown", handleOutsideClick);

        return (() => {
            document.removeEventListener("mousedown", handleOutsideClick);
        })
    })

    const handleCancel = () => {
        form.resetFields();
        setModalOpen(false)
    }

    async function handleSubmit() {
        try {
            if (!employeeId) return;
            await wish.mail(employeeId, msg);
            setModalOpen(false);
            setMsg('');
            message.success("Wish sent successfully!")
        } catch (error) {
            console.log("Failed to send wish");
        }
    }

    const updateSelection = (e: React.SyntheticEvent<HTMLTextAreaElement>) => {
        selectionRef.current = {
            start: e.currentTarget.selectionStart,
            end: e.currentTarget.selectionEnd,
        };
    };

    function insertEmoji(emojiObj: any) {
        const textarea = textAreaRef.current?.resizableTextArea?.textArea;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setMsg(prevWish => {
            const newText =
                prevWish.slice(0, start) +
                emojiObj.emoji +
                prevWish.slice(end);

            requestAnimationFrame(() => {
                textarea.focus();
                const pos = start + emojiObj.emoji.length;
                textarea.setSelectionRange(pos, pos);
            });

            return newText;
        });
    }


    return (
        <Modal
            title={<h4 className={'wish-email-modal__title'}>
                Share Your Wish
                <p className={'wish-email-modal__description'}>
                    Deliver your wish directly to the recipient's personal email.
                </p>
            </h4>}
            className={'hrms-app modal wish-email-modal'}
            open={openModal}
            onCancel={handleCancel}
            onOk={handleSubmit}
            okText={"Send"}
        >
            <div className={'wish-email-modal__text-emoji-wrapper'}>
                <TextArea
                    className={'wish-email-modal__input-box'}
                    ref={textAreaRef}
                    value={msg}
                    onChange={(e) => setMsg(e.target.value)}
                    onClick={updateSelection}
                    onKeyUp={updateSelection}
                    onSelect={updateSelection}
                    placeholder={"Write your wish"}
                />
                <SmilePlus className={`wish-email-modal__icon ${openEmojiPicker ? 'active' : 'inactive'}`}
                           onClick={() => setOpenEmojiPicker(true)}/>

                {openEmojiPicker && (
                    <div className="wish-email-modal__emoji-picker" ref={emojiRef}>
                        <EmojiPicker
                            emojiStyle={EmojiStyle.GOOGLE}
                            width={'100%'}
                            height={300}
                            previewConfig={{
                                showPreview: false,
                            }}
                            onEmojiClick={insertEmoji}
                        />
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default WishEmailModal;
